module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0104.jpg?v=d587beab";